module.exports = __webpack_public_path__ + "img/newlogo.0ad3400b.png";